import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const NewCreateModeReport = () =>
  import('./components/NewCreateModeReport.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/new-reports'),
      component: SettingsContent,
      props: {
        headerTitle: 'REPORT.HEADER',
        icon: 'chat',
        keepAlive: false,
      },
      children: [
        {
          path: '',
          redirect: 'conversation',
        },
        {
          path: 'conversation',
          name: 'new_conversation_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: Index,
        },
        {
          path: 'create-mode',
          name: 'new_create_mode_reports',
          meta: {
            permissions: ['administrator', 'report_manage'],
          },
          component: NewCreateModeReport,
        },
      ],
    },
  ],
};
